import { type MyAccountDataJSP, type MyAccountData } from "./myAccountTypes";
import { AFFILIATE_FORM_KEY } from "~/features/affiliate/components/AffiliateFormSection";
import { transformSalesPartnerDTO } from "~/domains/affiliate/utils/utils";
import { getSavedAffiliatePartner_toBeRemoved } from "~/domains/affiliate/utils/utilsToRefactorOut";

export function transformMyAccountData(dto: MyAccountDataJSP): MyAccountData {
  const { titleCode, salutationCode, line1, line2, isSalesPartnerSaved, selectedSubsidiary, ...inputFieldValues } =
    dto.inputFieldValues;
  return {
    ...dto,
    inputFieldValues: {
      ...inputFieldValues,
      title: titleCode,
      salutation: salutationCode,
      address: line1,
      addressAdditional: line2,
      oldPassword: "", //field
      newPassword: "",
      newPasswordConfirmation: "",
      privacyPolicy: dto.privacyPolicy,
      termsTraining: false,
      [AFFILIATE_FORM_KEY]: {
        id: isSalesPartnerSaved ? getSavedAffiliatePartner_toBeRemoved()?.affiliateId ?? "" : "",
        subsidiary: selectedSubsidiary,
      },
    },
    affiliates: dto.affiliates.map(transformSalesPartnerDTO),
  };
}
